import { cpmConstants } from "../actions/actionTypes";

export const cpmReducer = (state = {}, action) => {
  if (action != null) {
    switch (action.type) {
      case cpmConstants.CPM_REQUEST:
        return {};
      case cpmConstants.CPM_SUCCESS:
        return {
          consents: action.consents,
        };
      case cpmConstants.CPM_FAILURE:
        return { error: true };
      default:
        return state;
    }
  }
};
